import React, { createContext, useContext, useState, useEffect } from 'react';
import { customerApi } from '../utils/api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('customer_token');
    if (token) {
      customerApi.get('/customers/me')
        .then(r => setCustomer(r.data))
        .catch(() => localStorage.removeItem('customer_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = (token, customerData) => {
    localStorage.setItem('customer_token', token);
    setCustomer(customerData);
  };

  const logout = () => {
    localStorage.removeItem('customer_token');
    setCustomer(null);
  };

  return (
    <AuthContext.Provider value={{ customer, loading, login, logout, isLoggedIn: !!customer }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
